import React, { useContext } from "react";
import { connect } from "react-redux";

import List from '@material-ui/core/List';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import PersonIcon from '@material-ui/icons/Person';
import HomeIcon from '@material-ui/icons/Home';
import TodayIcon from '@material-ui/icons/Today';
import CommentIcon from '@material-ui/icons/Comment';
import ReportIcon from '@material-ui/icons/Report';
import AssessmentIcon from '@material-ui/icons/Assessment';
import PeopleIcon from '@material-ui/icons/People';
import EmailIcon from '@material-ui/icons/Email';
import EventNoteIcon from '@material-ui/icons/EventNote';
import EventAvailableIcon from '@material-ui/icons/EventAvailable';

import classes from "./NavigationItems.module.css"
import NavigationItem from "./NavagationItem/NavigationItem";
import { AuthContext } from "../../../containers/Auth/Auth";

const NavigationItems = (props) => {
    const {currentUser, isAdmin} = useContext(AuthContext);
    const {approved} = props;

    const nav = currentUser ?
        <NavigationItem link="/logout" text="Logout" icon={<ArrowBackIosIcon/>}/>
        :
        <NavigationItem link="/login" text="Login" icon={<ArrowForwardIosIcon/>}/>;

    const adminLinks = (
        <List className={classes.NavigationItems}>
            <NavigationItem link="/" exact text="Dashboard" icon={<HomeIcon/>}/>
            <NavigationItem link="/volunteerList" text="Volunteers" icon={<PeopleIcon/>}/>
            <NavigationItem link="/eventList" text="Event Templates" icon={<EventNoteIcon/>}/>
            <NavigationItem link="/scheduledEventList" text="Schedule Events" icon={<EventAvailableIcon/>}/>
            <NavigationItem link="/calendar" text="Calendar" icon={<TodayIcon/>}/>
            <NavigationItem link="/email" text="Send Emails" icon={<EmailIcon/>}/>
            <NavigationItem link="/report" text="Reports" icon={<AssessmentIcon/>}/>
            {nav}
        </List>
    );
    const userLinks = (
        <List className={classes.NavigationItems}>
            <NavigationItem link="/" exact text="Home" icon={<HomeIcon/>}/>
            {currentUser && <NavigationItem link="/comments" text="Anonymous Reporting" icon={<ReportIcon/>}/>}
            {currentUser && <NavigationItem link="/contactUs" text="Contact Us" icon={<CommentIcon/>}/>}
            {(currentUser && approved === "true") &&
            <NavigationItem link="/account" text="Account" icon={<PersonIcon/>}/>}
            {(currentUser && approved === "true") &&
            <NavigationItem link="/calendar" text="Calendar" icon={<TodayIcon/>}/>}
            {nav}
        </List>
    );

    return isAdmin ? adminLinks : userLinks;
};

const mapStateToProps = state => {
    return {
        approved: state.auth.approved
    };
};

export default connect(mapStateToProps)(NavigationItems);
